import { useContext } from "react";
import { ConfigContext } from "../providers/ConfigContext";
import useMakeApiRequest from "./useMakeApiRequest";

const useMakeSession = () => {
  const { apiBase } = useContext(ConfigContext);
  const makeApiRequest = useMakeApiRequest("POST");
  const addSession = async (fairId: any) => 
    await makeApiRequest(`${apiBase}/api/session?fairId=${fairId}`, {});

  return [addSession];
};

export default useMakeSession;
